var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-checkbox',{attrs:{"value":1,"unchecked-value":0},on:{"change":_vm.onChangeCheckbox},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }